import { __rest, __assign } from 'tslib';
import React, { forwardRef } from 'react';
import { useMatchMedia } from '../../mq/esm';
import { Content } from './components/content/Component.js';
import { Controls } from './components/controls/Component.js';
import { Footer } from './components/footer/Component.js';
import { Header } from './components/header/Component.js';
import { Modal } from './Component.js';
import 'classnames';
import '../../shared/esm';
import './consts.js';
import './Context.js';
import '../../base-modal/esm';
import './ResponsiveContext.js';
import './layout.module-ad0a095a.js';
import '../../navigation-bar-private/esm';
import 'react-merge-refs';

var ModalResponsiveComponent = forwardRef(function (_a, ref) {
    var children = _a.children, _b = _a.breakpoint, breakpoint = _b === void 0 ? 1024 : _b, _c = _a.defaultMatchMediaValue, defaultMatchMediaValue = _c === void 0 ? true : _c, restProps = __rest(_a, ["children", "breakpoint", "defaultMatchMediaValue"]);
    var isDesktop = useMatchMedia("(min-width: ".concat(breakpoint, "px)"), defaultMatchMediaValue)[0];
    return (React.createElement(Modal, __assign({ ref: ref }, restProps, { view: isDesktop ? 'desktop' : 'mobile' }), children));
});
var ModalResponsive = Object.assign(ModalResponsiveComponent, {
    Header: Header,
    Content: Content,
    Footer: Footer,
    Controls: Controls,
});
ModalResponsiveComponent.displayName = 'ModalResponsiveComponent';

export { ModalResponsive };
